const store = {
    namespaced: true,
    state() {
        return {
            breadcrumbs: []
        }
    },
    getters: {
        getBreadcrumbs: state => state.breadcrumbs
    },
    mutations: {
        SET_BREADCRUMBS: (state, payload) => {
            const { breadcrumbs, currentProductPath = {} } = payload;
            const result = breadcrumbs.reduce((acc, item, index) => {
                const prevItem = acc[index - 1];
    
                acc.push({
                    title: item.categoryTitle,
                    route: prevItem ? `${prevItem.route}/${item.categoryUrl}` : `/${item.categoryUrl}`
                });
    
                return acc;
            }, []);
    
            if (Object.keys(currentProductPath).length > 0) {
                result.push(currentProductPath);
            }
    
            state.breadcrumbs = result;
        },
        CLEAR_BREADCRUMBS: state => (state.breadcrumbs = [])
    },
}

export default store